import React from "react"

/**
 * Order-form-wide behavior: Enter toggles checkboxes (like Space) and selects radios.
 * We keep it local to v2 order form components for consistency.
 */

/**
 * @param {React.InputHTMLAttributes<HTMLInputElement> & {
 *   checked: boolean,
 *   onCheckedChange: (checked: boolean) => void,
 * }} props
 */
export function OrderFormCheckbox({ checked, onCheckedChange, onKeyDown, ...rest }) {
    return (
        <input
            {...rest}
            type="checkbox"
            checked={Boolean(checked)}
            onKeyDown={(e) => {
                onKeyDown?.(e)
                if (e.defaultPrevented) return
                if (e.key !== "Enter") return
                e.preventDefault()
                onCheckedChange(!Boolean(checked))
            }}
            onChange={(e) => onCheckedChange(Boolean(e.target.checked))}
        />
    )
}

/**
 * @param {React.InputHTMLAttributes<HTMLInputElement> & {
 *   checked: boolean,
 *   onSelect: () => void,
 * }} props
 */
export function OrderFormRadio({ checked, onSelect, onKeyDown, ...rest }) {
    return (
        <input
            {...rest}
            type="radio"
            checked={Boolean(checked)}
            onKeyDown={(e) => {
                onKeyDown?.(e)
                if (e.defaultPrevented) return
                if (e.key !== "Enter") return
                e.preventDefault()
                onSelect()
            }}
            onChange={() => onSelect()}
        />
    )
}

